import { forwardRef, InputHTMLAttributes } from 'react';
import { v4 as uuidv4 } from 'uuid';
import cns from 'classnames';
import { css } from '@emotion/react';
import { ContextProps } from './FormControlContext';
import { withForm } from './withForm';

export const RADIO_CLASSNAME = '__mapui_radio';

const applyMainStyles =
  ({ hasBorder }: Pick<RadioProps, 'hasBorder'>) =>
  (theme) => {
    const defaultStyle = css(theme.form.radio.defaultStyles);

    const styles = [defaultStyle];

    if (hasBorder) {
      styles.push(css(theme.form.radio.hasBorder));
    }

    return css(...styles);
  };

export interface RadioProps
  extends InputHTMLAttributes<HTMLInputElement>,
    ContextProps {
  className?: string;
  hasBorder?: boolean;
  label?: string;
  id?: string;
  type?: string;
  cssOverride?: any;
}

const InternalRadio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      className = '',
      hasBorder = false,
      label = '',
      id,
      type = 'radio',
      ...others
    }: RadioProps,
    ref
  ) => {
    const compId = uuidv4();

    return (
      <label
        htmlFor={id || compId}
        css={applyMainStyles({ hasBorder })}
        className={cns(RADIO_CLASSNAME, className)}
      >
        {label && <span className="__mapui_radioLabel">{label}</span>}
        <input
          ref={ref}
          type={type}
          id={id || compId}
          {...others}
          className="__mapui_radioInput"
        />
        <div className="__mapui_radioControl" />
      </label>
    );
  }
);

InternalRadio.displayName = 'Radio';

export const Radio = withForm<RadioProps>(InternalRadio);
